import { HTMLAttributes } from 'react'
import { useParams } from 'react-router'
import { ObjectTypes, useObjectGet, useObjectUpdate } from '../api/object'
import { Paper } from '../components/paper'
import { useFormLayout } from '../layouts'
import { FormLayoutInPlace } from '../layouts/form-layout-in-place'

export function ObjectFormInPlace<O extends keyof ObjectTypes>({
	object,
	id,
	name,
	...rest
}: {
	object: O
	id: string
	name?: string
} & HTMLAttributes<HTMLDivElement>) {
	const { data: client, isSuccess } = useObjectGet(object, id)
	const { mutate: update } = useObjectUpdate(object, id)
	const { layout, isLoading: isLayoutLoading } = useFormLayout(object, name)

	if (!isSuccess || isLayoutLoading) return null

	return (
		<Paper {...rest}>
			<div className="grid gap-x-4 items-start">
				<table>
					<tbody>
						<FormLayoutInPlace<O> layout={layout} data={client} onUpdate={update} />
					</tbody>
				</table>
			</div>
		</Paper>
	)
}

export function ObjectFormInPlaceRoute() {
	const { object, id } = useParams<{ object: keyof ObjectTypes; id: string }>()

	if (!object || !id) throw new Error('Invalid invocation')

	return <ObjectFormInPlace object={object} id={id} />
}
